<template>
  <v-container fluid>
    <v-card class="mb-4">
      <v-toolbar card color="primary" dark dense>
        <v-spacer></v-spacer>
        <v-toolbar-title>{{$t('instructions.listTitle')}}</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-title>
        <v-spacer></v-spacer>
        <v-text-field
          append-icon="search"
          :label="$t('general.search')"
          single-line
          hide-details
          v-model="search"
        ></v-text-field>
        <v-spacer></v-spacer>
      </v-card-title>
      <data-table
        :items="allInstructions"
        :headers="instructionsHeaders"
        :loading="instructionsLoading"
        :search="search"
        @selected="(value) => selected = value"
        @edit="editSelection"
      ></data-table>
    </v-card>
    <v-fab-transition>
      <v-btn
        v-if="showAddButton"
        fab
        dark
        color="primary"
        bottom
        right
        fixed
        @click.native="addDialog = true"
      >
        <v-icon dark>add</v-icon>
      </v-btn>
    </v-fab-transition>
    <v-fab-transition>
      <v-btn
        fab
        dark
        color="red"
        bottom
        right
        fixed
        @click.native="deleteDialog = true"
        style="right: 80px;"
        v-if="selected.length > 0"
      >
        <v-icon dark>delete</v-icon>
      </v-btn>
    </v-fab-transition>
    <instruction-add :active="addDialog" @closedialog="addDialog = false"></instruction-add>
    <instruction-edit
      :active="editDialog"
      :id="instructionId"
      @closedialog="editDialog = false; instructionId = null"
    ></instruction-edit>
    <confirmation-dialog
      :active="deleteDialog"
      title="Confirmation ?"
      :message="$tc('instructions.deleteConfirmation', selected.length, {count: selected.length})"
      :loading="instructionsLoading"
      @confirmation="deleteDemandProfile"
      @cancel="deleteDialog = false"
    ></confirmation-dialog>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import DataTable from "@/components/DataTable";
import ConfirmationDialog from "@/components/ConfirmationDialog";
import InstructionEdit from "./Instruction-edit";
import InstructionAdd from "./Instruction-add";

export default {
  
  name: "Instructions",

  components: {
    DataTable,
    ConfirmationDialog,
    InstructionEdit,
    InstructionAdd
  },

  data() {
    return {
      showAddButton: false,
      search: "",
      selected: [],
      editDialog: false,
      deleteDialog: false,
      addDialog: false,
      instructionId: ""
    };
  },

  mounted() {
    this.getAllInstructions()
    setTimeout(() => (this.showAddButton = true), 500)
  },

  methods: {

    editSelection(value) {
      this.instructionId = value;
      this.editDialog = true;
    },

    async deleteDemandProfile() {
      if (
        await this.deleteInstructions(this.selected.map(item => item._id))
      ) {
        this.deleteDialog = false;
        this.selected = [];
      }
    },

    ...mapActions('instructions', {
      getAllInstructions: 'getAll',
      deleteInstructions: 'delete'
    })

  },

  computed: {
    ...mapGetters('instructions', {
      allInstructions: 'list',
      instructionsHeaders: 'headers',
      instructionsLoading: 'loading'
    })
  }
};
</script>
